'use client';

import { ReactNode } from 'react';

import Image from 'next/image';

import Logo from '@icons/Logo.svg';
import { ROLES, RoleType } from 'types/roles';

import {
  ContentContainer,
  ContentWrapper,
  IlustrationWrapper,
  ImageContainer,
  LayoutContainer,
  LogoContainer,
} from './styles';

/**
 * ResponsiveAuthLayout Component
 * Component provides a responsive layout for authentication pages.
 */

interface AuthLayoutProps {
  children: ReactNode;
  role?: RoleType;
}

const getIllustrationByRole = (role?: RoleType): string => {
  switch (role) {
    case ROLES.ADMIN:
      return '/assets/images/Illustration-admin.png';
    case ROLES.SCHOOL:
      return '/assets/images/Illustration-school.png';
    case ROLES.TEACHER:
    default:
      return '/assets/images/Illustration.png';
  }
};

export const AuthLayout = ({ children, role }: AuthLayoutProps) => {
  const illustrationSrc = getIllustrationByRole(role);

  return (
    <LayoutContainer className="auth-page">
      <ContentWrapper>
        <LogoContainer>
          <Logo />
        </LogoContainer>
        <ContentContainer>{children}</ContentContainer>
      </ContentWrapper>
      <ImageContainer>
        <IlustrationWrapper>
          <Image src={illustrationSrc} alt="Homescreen Illustration" fill />
        </IlustrationWrapper>
      </ImageContainer>
    </LayoutContainer>
  );
};
